var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilIcon = function SvgPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h21v21H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m19.107 2.815-.932-.932a1.97 1.97 0 0 0-2.783 0L3.81 13.453c-.395.39-.682.877-.834 1.411l-1.273 4.41 4.417-1.273a3.37 3.37 0 0 0 1.41-.834L19.108 5.604a1.97 1.97 0 0 0 0-2.789M6.599 16.235a1.97 1.97 0 0 1-.847.506l-2.133.61.617-2.126c.092-.32.264-.611.499-.847l8.118-8.104 1.864 1.857zM18.182 4.673 15.648 7.22l-1.87-1.87 2.533-2.534a.66.66 0 0 1 .473-.19c.172 0 .337.069.46.19l.938.932a.656.656 0 0 1 0 .925",
    clipRule: "evenodd"
  })));
};
export default SvgPencilIcon;